<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-16 12:00:31
 * @LastEditTime: 2019-08-16 12:02:35
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
            title="批量导入"
            :visible="true"
            width="50%"
            :append-to-body=true
           
            :before-close="handleClose">
   <div>
        <div class="title">成功导入{{table.total_success}}条,失败{{table.total_failure}}条</div>
      <div class="tableBox" v-loading="loading">
            <table class="table table-striped table-bordered table-hover">
                <thead>
                <tr>
                    <th style="width: 40px;">经销商/门店编号</th>
                    <th style="width: 140px">经销商/门店名称</th>
                    <th style="width: 120px">商品编号</th>
                    <th style="width: 120px">商品名称</th>
                    <th style="width: 120px">商品价格</th>
                    <th style="width: 240px">是否赠品</th>
                    <th style="width: 220px">商品属性</th>
                    <th style="width: 120px">失败原因</th>
     
                </tr>
                </thead>
                <tbody>
                <template v-for="(item,index) in tableData">
                    <template v-for="(val,num) in item.return_goods">
                        <tr>
                            <template v-if="item.return_goods.length > 0 && num > 0">
                                <td colspan="10"></td>
                            </template>
                            <template v-else>
                                <td style="white-space: nowrap;">{{item.sn}}</td>
                                <td style="white-space: nowrap;">{{item.name}}</td>
                            </template>
                            <td style="white-space: nowrap;">{{val.product_sn}}</td>
                            <td style="white-space: nowrap;">{{val.product_name}}</td>
                            <td style="white-space: nowrap;">{{val.price}}</td>
                             <td style="white-space: nowrap;">
                                <span v-if="val.isgift == 1">赠品</span>
                                <span v-else>非赠品</span>
                            </td>
                            <td style="white-space: nowrap;">{{val.attribute_name}}</td>
                            <td style="white-space: nowrap;">{{item.error_msg}}</td>               
                        </tr>
                    </template>
                </template>

                </tbody>
            </table>
        </div>
        <el-button type="primary" @click='done()'>完成</el-button>
   </div>
  </el-dialog>
</template>
<script>
export default {
    name:'importDetail',
    data(){
        return{
          
        }
    },
    methods:{
        done(){

             this.$emit('refresh');
        },
        handleClose(){
             this.$emit('handleClose');

        }
    },
    props:{
        table:Object
    },
    created(){
        console.log(this.table)
    }
}
</script>

<style lang="scss" scoped>
/deep/.cell {
    height: auto;
// overflow: visible;


img{
    height:100px;
}
} 
/deep/ .price >div{
    text-align: left;
}
/deep/.el-form--inline .el-form-item{
    margin-right: 15px;
}
/deep/table{
    overflow-y: scroll;
  tbody  tr{
        height: 200px;
    }
} 
 .tableBox {
        overflow-x: scroll;
        .table {
            width: 300%;
        }
    }
</style>


